<div class="modal-body">
    <div class="row mb-3">
        <div class="col-12 text-gris-oscuro fw-bold">
            <h4 class="fw-bold mas-grande mt-3">Datos de Investigación</h4>
        </div>
    </div>
    <form [formGroup]="formGroup">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <div class="mb-3">
                        <label class="form-label" for="nombre">Nombre</label>
                        <input type="text" name="nombre" id="nombre" class="form-control" placeholder="Nombre de Investigación" formControlName="nombre"
                            required>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label class="form-label" for="cliente">Cliente</label>
                    <ng-select [items]="$any(clientes | async)" [clearable]="false" placeholder="Cliente" bindLabel="nombre"
                        formControlName="cliente" id="cliente">
                    </ng-select>
                </div>
            </div>
            <div class="col flex-grow-0 my-auto pt-1">
                <a class="btn btn-link text-nowrap" (click)="crearCliente()">Agregar cliente</a>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label for="fechafin" class="form-label">Deadline</label>
                    <input type="date" name="fechafin" id="fechafin" class="form-control" required
                        formControlName="fechafin">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-check-label" for="respuestasMaximas">Respuestas Máximas</label>
                    <input type="number" name="respuestasMaximas" id="respuestasMaximas" class="form-control" formControlName="respuestasMaximas" value="500">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label" for="pais">Crear grupos de País</label>
                    <ng-select [items]="$any(paises | async)" [clearable]="false" placeholder="Seleccionar paises"
                        bindLabel="nombre" formControlName="paises" [multiple]="true" id="pais">
                    </ng-select>
                </div>
            </div>
        </div>
    </form>
    <div class="row solo-botones">
        <div class="col-12 text-end">
            <button class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
            <button class="btn btn-primary" (click)="guardar()" [disabled]="formGroup.invalid">Guardar</button>
        </div>
    </div>
</div>
